import React, { useState } from 'react';
import { Form, Input, Select } from 'antd';
import styles from './index.scss';
import { trim, capitalize } from 'lodash';
import classnames from 'classnames';
import Validator from 'validatorjs';

const { Option, OptGroup } = Select;

const RunInstanceName = ({
  saveRunInstanceConfigToStore,
  values,
  handleChange,
  handleOnBlur,
  modulesList
}) => {
  const [form] = Form.useForm();

  const [errors, setErrors] = useState({
    name: '',
    description: '',
    sourceId: ''
  });

  const validatingRegex = (pattern, value) => {
    let regex = new RegExp(trim(pattern, '/'));
    return regex.test(value.trimEnd());
  };

  const onChangeHandler = (e) => {
    const { name, value, pattern, min, max } = e.target;
    handleChange(name, value);
    let newData = {
      ...values,
      [name]: value
    };
    if (/^[\s_\-]$/.test(value.charAt(0))) {
      // for space and special characters in starting of string
      setErrors({
        ...errors,
        [name]: capitalize(
          `${name} cannot start with space or special characters`
        )
      });
    } else if (!validatingRegex(pattern, value)) {
      // for Regex validation
      setErrors({
        ...errors,
        [name]: `Must be ${min}-${max} characters (a-z A-Z 0-9 _ - space)`
      });
    } else
      setErrors({
        ...errors,
        [name]: ''
      });
    checkFormValidation(newData);
  };

  const onBlur = (e) => {
    const { name, value, required } = e.target;
    if (value === '' && required) {
      // for Required validation
      setErrors({
        ...errors,
        [name]: `Please input run instance ${name}`
      });
      handleOnBlur();
    }
  };

  const checkFormValidation = (newData) => {
    let rules = {
      name: ['required', 'regex:/^[a-zA-Z0-9]([a-zA-Z0-9_\\s\\-]){2,99}$/'],
      description: [
        'required',
        'regex:/^[a-zA-Z0-9]([a-zA-Z0-9\\s_\\-]){2,199}$/'
      ],
      sourceId: ['required']
    };

    let validation = new Validator(newData, rules);
    if (saveRunInstanceConfigToStore)
      saveRunInstanceConfigToStore(
        'runInstanceConfig',
        newData,
        validation.passes()
      );
  };

  const moduleSelectHandler = (val) => {
    handleChange('sourceId', val);
    let newData = {
      ...values,
      sourceId: val
    };
    setErrors({
      ...errors,
      sourceId: ''
    });
    checkFormValidation(newData);
  };

  const onBlurSelectHanlder = () => {
    if (values?.sourceId !== '')
      setErrors({
        ...errors,
        sourceId: ''
      });
    else
      setErrors({
        ...errors,
        sourceId: 'Please select run instance module.'
      });
  };

  return (
    <Form className={styles.form} initialValues={values} form={form}>
      <div style={{ maxWidth: '256px', paddingTop: '24px' }}>
        <label
          required="required"
          className={classnames(styles.label, styles.required)}>
          Run Instance Name
        </label>
        <Input
          name="name"
          id={'runInstanceName-input'}
          title=""
          className={styles.input}
          value={values?.name}
          onChange={onChangeHandler}
          placeholder="Run Instance Name"
          onBlur={onBlur}
          required={true}
          min={3}
          max={100}
          pattern={/^[a-zA-Z0-9]([a-zA-Z0-9\s_\-]){2,99}$/}
        />
        {errors.name !== '' && (
          <p className={styles.errorMessage} id="error_name">
            {errors.name}
          </p>
        )}
      </div>
      <div style={{ maxWidth: '556px' }}>
        <label className={classnames(styles.label, styles.required)}>
          Run Instance Description
        </label>
        <Input
          name="description"
          id={'runInstanceName-description'}
          title=""
          className={styles.input}
          value={values?.description}
          onChange={onChangeHandler}
          placeholder="Run Instance Description"
          onBlur={onBlur}
          required={true}
          min={3}
          max={200}
          pattern={/^[a-zA-Z0-9]([a-zA-Z0-9\s_\-]){2,199}$/}
        />
        {errors.description !== '' && (
          <p className={styles.errorMessage} id="error_description">
            {errors.description}
          </p>
        )}
      </div>
      <div
        style={{ maxWidth: '256px', display: 'flex', flexDirection: 'column' }}>
        <label className={classnames(styles.label, styles.required)}>
          Run Instance Module
        </label>
        <Select
          placeholder="Select Module"
          value={values?.sourceId ? values?.sourceId : null}
          id="moduleType"
          dropdownClassName="moduleType"
          onChange={moduleSelectHandler}
          onBlur={onBlurSelectHanlder}>
          <OptGroup label="Select Module">
            {modulesList?.map((item, index) => (
              <Option value={item.value} key={index}>
                {item.label}
              </Option>
            ))}
          </OptGroup>
        </Select>
        {errors.sourceId !== '' && (
          <p className={styles.errorMessage} id="error_module">
            {errors.sourceId}
          </p>
        )}
      </div>
    </Form>
  );
};

export default RunInstanceName;
